import { Address } from '../../address/models/address.model';

export class CustomerAddress extends Address {
    public isSameAsPhysical: boolean;
}
